import {createSlice} from '@reduxjs/toolkit'
import {setSwitchedRole} from './userRoleSlice'

const initialState = {
  userData: {
    isLoading: true,
    isAuthenticated: false,
    error: null,
    user: null,
  },
  partnerAffiliateCode: null,
  keapPartnerId: sessionStorage.getItem('keapPartnerId') || null,
  bundleId: sessionStorage.getItem('bundleId') || null,
  eaid: sessionStorage.getItem('eaid') || null,
  envConfig: null,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserData(state, action) {
      const user = action.payload
      state.userData = user
      // A partner id left in sessionStorage by another login in this tab must
      // not scope the new user's lists; bind the stored id to its owner.
      const email = user?.user?.email?.toLowerCase()
      if (email) {
        const owner = sessionStorage.getItem('keapPartnerIdOwner')
        if (owner && owner !== email) {
          state.keapPartnerId = null
          sessionStorage.removeItem('keapPartnerId')
        }
        sessionStorage.setItem('keapPartnerIdOwner', email)
      }
    },
    clearUserData(state) {
      state.userData = null
      state.keapPartnerId = null
      sessionStorage.removeItem('keapPartnerId')
      sessionStorage.removeItem('keapPartnerIdOwner')
    },
    setPartnerAC(state, action) {
      state.partnerAffiliateCode = action.payload
    },
    clearPartnerAC(state) {
      state.partnerAffiliateCode = null
    },
    setKeapPartnerId(state, action) {
      state.keapPartnerId = action.payload
      if (action.payload) {
        sessionStorage.setItem('keapPartnerId', action.payload)
      } else {
        sessionStorage.removeItem('keapPartnerId')
      }
    },
    clearKeapPartnerId(state) {
      state.keapPartnerId = null
      sessionStorage.removeItem('keapPartnerId')
    },
    setBundleId(state, action) {
      state.bundleId = action.payload
      if (action.payload) {
        sessionStorage.setItem('bundleId', action.payload)
      } else {
        sessionStorage.removeItem('bundleId')
      }
    },
    clearBundleId(state) {
      state.bundleId = null
      sessionStorage.removeItem('bundleId')
    },
    setEaid(state, action) {
      state.eaid = action.payload
      if (action.payload) {
        sessionStorage.setItem('eaid', action.payload)
      } else {
        sessionStorage.removeItem('eaid')
      }
    },
    clearEaid(state) {
      state.eaid = null
      sessionStorage.removeItem('eaid')
    },
    setEnvConfig(state, action) {
      state.envConfig = action.payload
    },
  },
  // A role switch changes whose lists the rep sees; drop the id and let it
  // re-resolve from the user's own metadata.
  extraReducers: builder => {
    builder.addCase(setSwitchedRole, state => {
      state.keapPartnerId = null
      sessionStorage.removeItem('keapPartnerId')
    })
  },
})

export const {
  setUserData,
  clearUserData,
  setPartnerAC,
  clearPartnerAC,
  setKeapPartnerId,
  clearKeapPartnerId,
  setBundleId,
  clearBundleId,
  setEaid,
  clearEaid,
  setEnvConfig,
} = userSlice.actions
export default userSlice.reducer
